module.exports = __webpack_public_path__ + "13658a6e6e35f3422bebf16a68b1f046.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/secondary_logo.png
// module id = 241
// module chunks = 0